import {gql} from "@apollo/client";
import {query} from "../../lib/apollo";

export async function searchCampaignConfirms(
    hpCampaignId: number,
    startDate: string,
    endDate: string,
    skip: number,
    limit: number,
    search: string
) {
    const q = gql`
      query q ($input: HpCampaignConfirmsInput!) {
        hpCampaignConfirms(input: $input) {
            count
            items {
                leadId
                dateSent
                publisherName
                confirm
                action
                zip
            }
        }
      }
    `;

    const variables = {
        input: {
            hpCampaignId,
            startDate,
            endDate,
            skip,
            limit,
            search: search || null,
        }
    };

    const response = await query(q, variables);
    if (!response || !response.hpCampaignConfirms) {
        return {count: 0, items: []};
    }

    return {
        count: response.hpCampaignConfirms.count,
        items: response.hpCampaignConfirms.items,
    };
}
